import ApplicationLoader from "@/ApplicationLoader";

import QuizContainer from "./QuizContainer";

const AppLoader = new ApplicationLoader(QuizContainer);

AppLoader.start();
